export default {
  changelog: {
    loading: "Cargando…",
    title: "Historial de versiones",
    subtitle: "Aquí puedes ver todas las mejoras y novedades que hemos añadido a la aplicación.",
    current: "Actual",
    initialVersion: "Versión inicial de la aplicación.",
  },
};
